import { api } from '@here/api'
import { ListTypes, type Pagination } from '..'

export const handleGetSubscribed = async (
	listType?: any,
	filters?: any,
	p_user_id?: string,
	pagination?: Pagination,
) => {
	if (!p_user_id || listType !== ListTypes.subscribed || !pagination) {
		return []
	}

	let query = api().rpc('get_user_subscribed_setups', {
		p_user_id,
	})

	// Apply limit + offset
	if (pagination.limit !== undefined && pagination.offset !== undefined) {
		query = query.range(pagination.offset, pagination.offset + pagination.limit - 1)
	}

	const { data, error } = await query

	return data || []
}
